export const VALIDATE_POLICY_INFO = 'oauth.VALIDATE_POLICY_INFO';
export const SET_TOKEN = 'oauth.SET_TOKEN';
export const SET_USER_NAME = 'app.SET_USER_NAME';
export const VALIDATE_VERIFICATION_CODE = 'oauth.VALIDATE_VERIFICATION_CODE';
export const SET_REQUIRE_VERIFICATION_CODE = 'oauth.SET_REQUIRE_VERIFICATION_CODE';
export const AUTHENTICATION_SUCCESS = 'oauth.AUTHENTICATION_SUCCESS';
export const RESET_AUTHENTICATION_INFO = 'oauth.RESET_AUTHENTICATION_INFO';
export const VALUE_CHANGED = 'oauth.VALUE_CHANGED';
export const TOGGLE_MODAL = 'oauth.TOGGLE_MODAL';
export const LOADING = 'oauth.LOADING';
export const SET_PURCHASE_DATE = 'oauth.SET_PURCHASE_DATE';
export const QUESTION_LIST = [
  {
    id: 1,
    question: 'Q.What can I expect once my claim has been lodged?',
    anwser: '<p>Once all the necessary documentation has been provided, your claim will be processed within 10 business days.<br><br>Please note: we need certain documents to properly assess your claim. We are unable to assess claims lodged without the requried documentation. If you have provided some, but not all documentation, we’ll be in touch within 10 business days requesting further documents.<br><br>For us to process your claim quickly, we will need certain documents and evidence from you. For each type of claim, we outline exactly what kind of documentation we need in our claims form.</p> ',
    isOpen: false,
    name: 'secondQuestionOpen',
  },
  {
    id: 2,
    question: 'Q.Can I lodge a claim if I don\'t have all of the required documents?',
    anwser: '<p>We are able to assess claims far quicker if we receive all the required documentation along with your claim. However, you can lodge a claim right now and attach any missing documents at a later stage.</p>',
    isOpen: false,
    name: 'thirdQuestionOpen',
  },
  {
    id: 3,
    question: 'Q.How do I add more documents to my existing claim?',
    anwser: '<p>Once your claim has been lodged, you can provide additional documentation via the Online Claims Form attachment page. It is the fastest way to provide us with additional documentation. All you need to do is enter your Claims Number and attach your documents. They will then appear immediately in our systems. If you have lodged a claim by phone, then please email your attachments to info@travelclaimscentre.com.<br><br>You can also provide additional documentation by emailing info@travelclaimscentre.com, including the Claims Number in the subject line. However, as the inbox is reviewed periodically, it may add unnecessary delays to your assessment. The Online Claims Form attachment page is the fastest way to provide additional documentation.<br>&nbsp;</p>',
    isOpen: false,
    name: 'fourthQuestionOpen',
  },
];



// WEBPACK FOOTER //
// ./app/containers/Login/constants.js